var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_search"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M19.5383 20.5769L13.2576 14.2961C12.7576 14.7089 12.1826 15.032 11.5326 15.2653C10.8826 15.4987 10.2101 15.6153 9.51525 15.6153C7.80609 15.6153 6.35957 15.0236 5.1757 13.84C3.99184 12.6564 3.3999 11.2103 3.3999 9.50157C3.3999 7.79284 3.99169 6.34616 5.17525 5.16154C6.35882 3.97694 7.80497 3.38464 9.5137 3.38464C11.2224 3.38464 12.6691 3.97658 13.8537 5.16044C15.0383 6.34431 15.6306 7.79083 15.6306 9.49999C15.6306 10.2141 15.5108 10.8961 15.271 11.5461C15.0313 12.1961 14.7114 12.7615 14.3114 13.2423L20.5922 19.5231L19.5383 20.5769ZM9.51525 14.1154C10.8037 14.1154 11.8951 13.6683 12.7893 12.774C13.6835 11.8798 14.1307 10.7885 14.1307 9.49999C14.1307 8.21153 13.6835 7.12018 12.7893 6.22594C11.8951 5.33171 10.8037 4.88459 9.51525 4.88459C8.22679 4.88459 7.13544 5.33171 6.2412 6.22594C5.34699 7.12018 4.89988 8.21153 4.89988 9.49999C4.89988 10.7885 5.34699 11.8798 6.2412 12.774C7.13544 13.6683 8.22679 14.1154 9.51525 14.1154Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.97ddc1f8f69ad5c8b8791ffabf52958f.svg";
export { ForwardRef as ReactComponent };